import { render, staticRenderFns } from "./examMarks.html?vue&type=template&id=2a32a7fc&external"
import script from "./examMarks.vue?vue&type=script&lang=js"
export * from "./examMarks.vue?vue&type=script&lang=js"
import style0 from "./examMarks.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports